var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientInvitationUIManager {
    constructor(environment, bannerUIManager, organizationsManager) {
        this.environment = environment;
        this.bannerUIManager = bannerUIManager;
        this.organizationsManager = organizationsManager;
    }
    get invitationLink() {
        const organization = this.organizationsManager.myOrganization.value;
        if (organization === NOT_LOADED || organization === null)
            return "";
        if (organization.vanitySubdomain) {
            return `https://${organization.vanitySubdomain}.${this.environment.WEB_ROOT_DOMAIN}/#/patients`;
        }
        else {
            return `${this.environment.WEBAPP_BASE_URL}/#/patients`;
        }
    }
    async copyInvitationLink() {
        await navigator.clipboard.writeText(this.invitationLink);
        this.bannerUIManager.displayBanner({ text: "Link copied to clipboard" });
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientInvitationUIManager.prototype, "invitationLink", null);
